let prefix = '/api/evidences';

function update(idEvidence, data){
    return window.axios.post(prefix+'/'+idEvidence+'/update',data);
}
export default {
    update
}